<template>
	<div class="container g-flex g-row-center" v-if="showList">
		<div class="total-width g-p-b-16">
			<div v-for="(item,index) in list" :key="index">
				<!--  选择城市为多选回显，单独处理  -->
				<div class="g-flex g-col-top" v-if="item.pId === 1" style="flex-flow:wrap !important;">
					<p class="g-font-16 main-text g-font-weight-6 g-m-t-15 g-nowrap">{{ item.label + '：' }}</p>
					<div class="g-flex g-rela" style="flex-flow:wrap !important;">
						<div class="tag-item g-nowrap g-m-r-5 pointer" @click="clearSelect(0)"
							:class="{'active':cityUnlimited ===1}">
							不限
						</div>
						<div class="g-flex">
							<div class="tag-item multiple-tag g-nowrap pointer g-rela"
								v-for="(sub,subIndex) in selectedCityList" :key="subIndex">
								{{ sub.dictValue }}
								<img src="@/assets/find-job/close-icon.png" class="del-icon" alt=""
									@click="delCity(subIndex)">
							</div>
						</div>
					</div>
					<div class="more-btn blue-text g-font-16 g-font-weight-6 pointer" @click="openAll(item,index)">
						全部城市 <i class="el-icon-arrow-right"></i>
					</div>
				</div>

				<!--  选择职业为多选回显，单独处理  -->
				<!--<div class="g-flex g-col-top" v-if="item.pId === 2">
					<p class="g-font-16 main-text g-font-weight-6 g-m-t-15 g-nowrap">{{ item.label + '：' }}</p>
					<div class="g-flex g-rela">
						<div class="tag-item g-nowrap g-m-r-5 pointer" @click="clearSelect(1)"
							:class="{'active':positionUnlimited ===1}">
							不限
						</div>
						<div class="g-flex">
							<div v-for="(sub,subIndex) in selectedPositionList" :key="subIndex">
								<div class="tag-item multiple-tag g-nowrap pointer g-rela">
									{{ sub.label }}
									<img src="@/assets/find-job/close-icon.png" class="del-icon" alt=""
										@click="delPosition(subIndex)">
								</div>
							</div>
						</div>
					</div>
					<div class="more-btn blue-text g-font-16 g-font-weight-6 pointer" @click="openAll(item,index)">
						全部职业 <i class="el-icon-arrow-right"></i>
					</div>
				</div>-->
					
				<div class="g-flex g-col-top" v-if="item.pId == 2">
					<p class="g-font-16 main-text g-font-weight-6 g-m-t-15 g-nowrap">{{ item.label + '：' }}</p>
					<div class="g-flex g-rela" style="flex-flow:wrap !important;">
						<div class="tag-item g-nowrap g-m-r-5 pointer" @click="selectIndex(index)"
							:class="{'active':selectedList[index].subItem.dictKey ===''}">
							不限
						</div>
						<div class="tag-item g-nowrap pointer"
							:class="{'active':selectedList[index].subItem.dictKey===sub.dictKey}"
							@click="selectItem(index,subIndex)" v-for="(sub,subIndex) in item.sublist" :key="subIndex" v-if="subIndex<maxNum">
							{{ sub.dictValue }}
						</div>
						<div class="tag-item g-nowrap pointer blue-text" @click="openPost" style="color:blue !important">
							{{maxNum>10?'-收缩':'+展开'}}
						</div>
					</div>
					
				</div>
				<!--   其他单选   -->
				<div class="g-flex g-col-top" v-if="item.pId !== 1&&item.pId !== 2">
					<p class="g-font-16 main-text g-font-weight-6 g-m-t-15 g-nowrap">{{ item.label + '：' }}</p>
					<div class="g-flex g-rela" style="flex-flow:wrap !important;">
						<div class="tag-item g-nowrap g-m-r-5 pointer" @click="selectIndex(index)"
							:class="{'active':selectedList[index].subItem.dictKey ===''}">
							不限
						</div>
						<div class="tag-item g-nowrap pointer"
							:class="{'active':selectedList[index].subItem.dictKey===sub.dictKey}"
							@click="selectItem(index,subIndex)" v-for="(sub,subIndex) in item.sublist" :key="subIndex">
							{{ sub.dictValue }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--  城市选择  -->
		<city-popup ref="popup1" @submit="selectCity" :list="cityList" v-if="cityList.length"></city-popup>
		<!--  职位选择  -->
		<job-position-popup ref="popup2" @submit="selectPosition" :list="positionList" v-if="positionList.length">
		</job-position-popup>
	</div>
</template>

<script>
	import cityPopup from "@/views/find-job/components/city-popup";
	import jobPositionPopup from "@/views/find-job/components/job-position-popup";

	export default {
		components: {
			cityPopup,
			jobPositionPopup
		},
		name: "sort-selection",
		props: {
			list: {
				type: Array,
				default: [],
			}
		},
		data() {
			return {
				showList: false, //渲染列表
				selectedList: [], //已选择的列表
				selectedCityList: [], //已选择的城市列表
				selectedPositionList: [], //已选择的职位列表
				cityList: [],
				positionList: [],
				positionUnlimited: 1,
				cityUnlimited: 1,
				maxNum:10
			}
		},
		watch: {

			selectedList: {
				handler(n, o) {
					this.$emit('changeParams',JSON.parse(JSON.stringify(n)))
					
				},
				deep: true // 深度监听父组件传过来对象变化
			},
			selectedCityList: {
				handler(n, o) {
					this.changeCityParams(n)
				},
				deep: true // 深度监听父组件传过来对象变化
			},
			selectedPositionList: {
				handler(n, o) {
					this.changePosiParams(n)
				},
				
			}
		},
		mounted() {
			this.initList()
		},
		methods: {
			openPost(){
				this.maxNum=this.maxNum>10?this.maxNum=10:this.maxNum=100
			},
			changeCityParams(val){
				console.log('!!!!!!!!!!')
				
				this.selectedList[0].subItem=val
			},
			changePosiParams(val){
				this.selectedList[1].subItem=val
			},
			/**
			 *  当前模拟的场景为，后端数据库对分类进行了单独存储（子集id可重复）
			 *  如果后端数据库中没有对分类单独存储，请根据后端返回的具体数据进行处理
			 */
			// 初始化数组
			initList() {
				// 然后对已选择的列表进行默认中 ’不限‘ 的操作
				for (let i of this.list) {
					this.selectedList.push({
						label: i.label, //父级label
						pId: i.pId, //父级id
						subItem: {
							dictKey: '',
							dictValue: '不限'
						}, //默认选中‘不限’
					})
				}


				// 等数组初始化完成后再渲染列表
				setTimeout(() => {
					this.showList = true
				}, 100)
			},
			// 选择列表
			selectItem(index, subIndex) {
				// 将选择的对象重新赋值
				//debugger
				this.selectedList[index].subItem = this.list[index].sublist[subIndex]
			},
			//  打开更多
			openAll(val) {

				console.log(this.$refs)
				// 城市 查看更多
				if (val.pId === 1) {
					console.log(val)
					this.cityList = val.sublist
					this.$refs.popup1.open()
				} else if (val.pId === 2) {
					// 职业 查看更多
					this.positionList = val.sublist
					this.$refs.popup2.open()
				}
			},
			//  选择不限
			selectIndex(index) {

				this.selectedList[index].subItem = {
					dictKey: '',
					dictValue: '不限'
				}

			},

			// 城市、职位选择不限
			clearSelect(val) {
				// 城市选择不限，清空城市列表
				if (val === 0) {
					this.selectedCityList = []
					this.cityUnlimited = 1
				}
				// 职业选择不限，清空职业列表
				else {
					this.positionUnlimited = 1
					this.selectedPositionList = []
				}
			},

			//  城市弹窗选择回调
			selectCity(city) {
				this.selectedCityList = city
				this.cityUnlimited = 0
				console.log(this.selectedCityList)
			},
			//  职位弹窗选择回调
			selectPosition(position) {
				this.selectedPositionList = position
				this.positionUnlimited = 0
			},
			//  城市选择删除
			delCity(index) {
				this.selectedCityList.splice(index, 1)
			},
			// 职业选择删除
			delPosition(index) {
				this.selectedPositionList.splice(index, 1)
			},
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		background: #fff;
	}

	.main-text {
		height: 30px;
		line-height: 30px;
	}

	.tag-list {
		width: 82%;
		overflow-x: scroll;
	}

	.tag-item {
		padding: 0 12px;
		height: 30px;
		line-height: 30px;
		color: #666;
		margin-top: 15px;
	}

	.more-btn {
		background: #fff;
		height: 30px;
		line-height: 30px;
		padding: 0 10px;
		margin-top: 15px;
	}

	.active {
		color: #fff;
		background: #407aff;
		padding: 0 10px;
		border-radius: 5px;
	}

	.multiple-tag {
		background: #f7f7f7;
		color: #666;
		margin: 15px 10px 0 10px;
	}

	.del-icon {
		width: 16px;
		height: 16px;
		position: absolute;
		right: -8px;
		top: -8px;
	}
</style>
